module.exports = __webpack_public_path__ + "img/upsell_page.84ac8c8a.png";